import styled from '@emotion/styled';
import { Div } from '../../../../layouts';

export const SwapButtonDesktopEl = styled(Div)`
    .odf-rtl && {
      left: auto;
      right: -16px;
    }
    && {
        left: -16px;
        top: 7px;
    }
`;
